import React from "react";
import { Table } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import styles from "./PatternListRow.module.scss";
import { useDispatch } from "react-redux";
import { removePatternById } from "../../../actions/patternActions";
import { PatternData } from "../../../types/siteTypes";
import ConfirmButtons from "../../../components/ConfirmButtons";
import { FormattedMessage } from "react-intl";
import ListValues from "../../../components/ListValues";
import {
  formatEur,
  getPatternPricingPresentation,
} from "../../../utils/patternPricing";

const PatternListRow = ({
  pattern,
}: {
  pattern: PatternData;
}) => {
  const { _id, name, user, categories } = pattern;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    showPromotionInfo,
    promotionBasePrice,
    currentEffectivePrice,
    lowestEffectivePrice,
    showOmnibusInfo,
  } = getPatternPricingPresentation(pattern);
  

  const deleteHandler = () => {
    dispatch(removePatternById(_id, navigate, true));
  };

  return (
    <Table.Row>
      <Table.Cell>
        <small>{_id}</small>
      </Table.Cell>
      <Table.Cell>{name}</Table.Cell>
      <Table.Cell>
        <div className={styles.priceCell}>
          {showPromotionInfo ? (
            <>
              <div className={styles.priceRow}>
                <span className={styles.oldPrice}>{formatEur(promotionBasePrice)}</span>
                <span className={styles.newPrice}>{formatEur(currentEffectivePrice)}</span>
              </div>
              {showOmnibusInfo && lowestEffectivePrice !== null && (
                <div className={styles.omnibusLine}>
                  <FormattedMessage
                    id="cart.omnibusInfo"
                    defaultMessage="Lowest price in 30 days before discount: {price}"
                    values={{ price: formatEur(lowestEffectivePrice) }}
                  />
                </div>
              )}
            </>
          ) : (
            <span>{formatEur(currentEffectivePrice)}</span>
          )}
        </div>
      </Table.Cell>
      <Table.Cell>
        <ListValues categoryItems={categories} />
      </Table.Cell>
      <Table.Cell>{(user as any)?.name}</Table.Cell>

      <Table.Cell className={styles.row}>
        <ConfirmButtons
          confirmHandler={deleteHandler}
          link={`/admin/pattern/${_id}/edit`}
          confirmText={<FormattedMessage id={"admin.adminList.confirmTitle"} />}
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default PatternListRow;
